(function () {
    'ngInject';

    angular.module('app.shared.services').factory('VectorAPIService', vectorAPIService);

    function vectorAPIService(HttpService) {
        /**
         * Get signed URL to upload a vector file to S3
         * @param {'base' | 'vector'} type type of vector
         * @param {String} filename optional filename of the vector file
         */
        async function getVectorUploadS3SignedUrl(type, filename) {
            const data = {
                type: type,
                filename: filename
            };
            const url = '/Vector/VectorUploadSignedUrl?' + $.param(data);
            return HttpService.get(url);
        }

        async function validateVectorFile(type, filename, includeDimensions, generateThumb) {
            const data = {
                type: type,
                filename: filename,
                includeDimensions: includeDimensions,
                generateThumb: generateThumb
            };
            const url = `/Vector/Validate/${encodeURIComponent(filename)}?${$.param(data)}`;
            return HttpService.get(url);
        }

        function epsFileToSvgString(filename) {
            const url = `/Vector/SvgString/${encodeURIComponent(filename)}`;
            return HttpService.get(url);
        }

        return {
            getVectorUploadS3SignedUrl: getVectorUploadS3SignedUrl,
            validateVectorFile: validateVectorFile,
            epsFileToSvgString: epsFileToSvgString
        };
    }
})();
